import {message} from '@sail/intl';

export const globalMessages = {
  // Utilities
  numberWithPlus: message<{number: string}>({
    id: 'mkt-ssr.global.number_with_plus',
    description:
      'Number with plus sign to indicate "or more". Use "+" after the number in Western languages, or equivalent indicator in your language (e.g., 以上 in Chinese/Japanese). {number} is the pre-formatted number value.',
    defaultMessage: '{number}+',
  }),
  // Common strings
  contactSales: message({
    id: 'mkt-ssr.global.contact_sales',
    defaultMessage: 'Contact sales',
    description: 'Link or button text to contact sales',
  }),
  startNow: message({
    id: 'mkt-ssr.global.start_now',
    defaultMessage: 'Start now',
    description: 'Call to action button text',
  }),
  // Product/brand names
  payments: message({
    id: 'mkt-ssr.global.payments',
    defaultMessage: 'Payments',
    description: 'Label for Payments product or category',
    translate: false,
  }),
};
